import {useEffect, useState} from 'react'

const DEBUG = 0

export const useTaskQueue = <TTaskState,>(initialState: TTaskState) => {
    const [state, setState] = useState<{
        taskState: TTaskState
        isRunning: boolean
        queue: {task: (state: TTaskState) => Promise<Partial<TTaskState>>; onError?: (error: any) => void}[]
    }>({taskState: initialState, isRunning: false, queue: []})

    useEffect(() => {
        const handleTask = async () => {
            const task = state.queue[0]
            if (task) {
                try {
                    const newState = await task.task(state.taskState)
                    DEBUG &&
                        console.log('useTaskQueue handled task [state.taskState, newState]', [
                            state.taskState,
                            newState,
                        ])
                    setState((state) => ({
                        queue: state.queue.slice(1),
                        isRunning: false,
                        taskState: {...state.taskState, ...newState},
                    }))
                } catch (error) {
                    console.log(error)
                    task.onError?.(error)
                    setState((state) => ({...state, queue: state.queue.slice(1), isRunning: false}))
                }
            }
        }

        if (state.isRunning) {
            handleTask()
        } else {
            if (state.queue.length) {
                setState((state) => ({...state, isRunning: true}))
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.isRunning])

    return [
        {
            ...state,
            enqueue: (
                task: (taskState: TTaskState) => Promise<Partial<TTaskState>>,
                onError?: (error: any) => void,
            ) => {
                setState((state) => ({...state, queue: [...state.queue, {task, onError}], isRunning: true}))
            },
            clear: () => {
                setState((state) => ({...state, queue: [], isRunning: false}))
            },
            setTaskState: (newState: Partial<TTaskState>) => {
                setState((state) => ({
                    ...state,
                    queue: [...state.queue, {task: async () => newState}],
                    isRunning: true,
                }))
            },
        },
    ]
}
